import React from "react";
import { Check, X } from "lucide-react";

interface PasswordRequirementsProps {
  password: string;
}

export const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  // Password requirements
  const requirements = [
    {
      text: "At least 8 characters",
      met: password.length >= 8,
    },
    {
      text: "At least one uppercase letter",
      met: /[A-Z]/.test(password),
    },
    {
      text: "At least one lowercase letter",
      met: /[a-z]/.test(password),
    },
    {
      text: "At least one number",
      met: /\d/.test(password),
    },
    {
      text: "At least one special character (!@#$%^&* etc.)",
      met: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    },
  ];
  
  // Don't show requirements until user types something
  if (password.length === 0) return null;
  
  return (
    <div className="mt-2 space-y-1 text-xs">
      <p className="text-gray-500 mb-1 font-medium">Password requirements:</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
        {requirements.map((req, i) => (
          <div key={i} className="flex items-center">
            {req.met ? (
              <Check className="h-3.5 w-3.5 mr-1.5 text-green-500 flex-shrink-0" />
            ) : (
              <X className="h-3.5 w-3.5 mr-1.5 text-red-400 flex-shrink-0" />
            )}
            <span className={req.met ? "text-gray-700" : "text-red-500 font-medium"}>
              {req.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
